import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import ReceivableFinancingPageUI from './ReceivableFinancingPageUI'

class ReceivableFinancingPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null,
      invoiceList: null,
      createMode: false,
      customerList: null,
      interestPaymentSubmitted: false,
      utilizeMode: false,
      customer: null,
      selectedCustomerId: null
    }
  }

  render() {
    return (
      <ReceivableFinancingPageUI
        context={this.props.context}
        account={this.state.account}
        invoiceList={this.state.invoiceList}
        customerList={this.state.customerList}
        onRefreshClick={this.onRefreshClick}
        //
        // createMode={this.state.createMode}
        // onCreateClick={() => { this.setState({ createMode: true }) }}
        // onCancelCreateInvoice={() => { this.setState({ createMode: false }) }}
        //
        disburseMode={this.state.disburseMode}
        selectedCustomerInvoiceId={this.state.selectedCustomerInvoiceId}
        onDisburseClick={this.onDisburseClick}
        onDisburseCancel={() => { this.setState({ disburseMode: false }) }}
        //
        onInterestPaymentClick={this.onInterestPaymentClick}
        interestPaymentSubmitted={this.state.interestPaymentSubmitted}
        onInterestPaymentCancel={() => { this.setState({ interestPaymentSubmitted: false }) }}
        interestPaymentSuccessMsg={this.state.interestPaymentSuccessMsg}
        interestPaymentErrorList={this.state.interestPaymentErrorList}
        //
        utilizeMode={this.state.utilizeMode}
        onUtilizeClick={this.onUtilizeClick}
        onUtilizeClickCancel={() => { this.setState({ utilizeMode: false }) }}
        selectedCustomerId={this.state.selectedCustomerId}
        customerInvoiceList={this.state.customerInvoiceList}
        //
        customer={this.state.customer}
        onCustomerChange={this.onCustomerChange}
        filteredCustomerList={this.state.filteredCustomerList}
        //
        feePaymentMode={this.state.feePaymentMode}
        onFeePaymentClick={this.onFeePaymentClick}
        onFeePaymentClickCancel={() => { this.setState({ feePaymentMode: false }) }}
      />
    )
  }

  onCustomerChange = (option) => {
    let customer = this.state.customerList.filter(c => c.customerId === option.value)[0]
    this.setState({ selectedCustomerId: option.value, customer: customer })
    this.getInvoices(this.props.context, option.value)
    let filter = { selectedCustomerId: option.value, customer: customer }
    sessionStorage.setItem(CacheKeys.SelectedCustomer(), JSON.stringify(filter))
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getCustomers(context)
    let filtersStr = sessionStorage.getItem(CacheKeys.SelectedCustomer())
    let filter = filtersStr ? JSON.parse(filtersStr) : {}
    this.setState({ selectedCustomerId: filter.selectedCustomerId, customer: filter.customer })
    if (filter.selectedCustomerId)
      this.getInvoices(context, filter.selectedCustomerId)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Account(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getCustomers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/customers`,
      cacheKey: CacheKeys.Customers(this.props.match.params.accountId),
      callback: this.getCustomersCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getCustomersCallback = (response) => {
    let customerList = response.customerList.map((customer) => {
      return { value: customer.customerId, label: customer.customerName }
    })
    this.setState({
      customerList: response.customerList,
      filteredCustomerList: customerList
    })
  }

  getInvoices(context, customerId) {
    let cacheManager = new CacheManager({
      resource: `/api/su/customers/${customerId}/customerInvoices`,
      cacheKey: CacheKeys.CustomerInvoices(customerId),
      callback: this.getInvoicesCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getInvoicesCallback = (response) => {
    let customerInvoiceList = response.invoiceList.map((invoice) => {
      return { key: invoice.customerInvoiceId, value: invoice.invoiceName + ' - ' + invoice.invoiceAmountF2 }
    })
    this.setState({ invoiceList: response.invoiceList, customerInvoiceList: customerInvoiceList })
  }

  onDisburseClick = (event) => {
    let customerInvoiceId = event.currentTarget.getAttribute('data-row-id')
    this.setState({ disburseMode: true, selectedCustomerInvoiceId: customerInvoiceId })
  }

  onInterestPaymentClick = (event) => {
    let customerInvoiceId = event.currentTarget.getAttribute('data-row-id')
    this.setState({
      interestPaymentSubmitted: true,
      selectedCustomerInvoiceId: customerInvoiceId
    })
  }

  onUtilizeClick = (event) => {
    let customerId = event.currentTarget.getAttribute('data-id')
    let customerInvoiceId = event.currentTarget.getAttribute('data-row-id')
    this.setState({ utilizeMode: true, selectedCustomerId: customerId, selectedCustomerInvoiceId: customerInvoiceId })
  }

  onFeePaymentClick = (event) => {
    let customerInvoiceId = event.currentTarget.getAttribute('data-row-id')
    this.setState({ feePaymentMode: true, selectedCustomerInvoiceId: customerInvoiceId })
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Customers(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.CustomerInvoices(this.state.selectedCustomerId))
    this.setState({ customerList: null, invoiceList: null },
      () => {
        this.getCustomers(context)
        this.getInvoices(context, this.state.selectedCustomerId)
      }
    )
  }

}

export default withRouter(ReceivableFinancingPageSF)
